import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.6403 7.40909C18.6305 7.39676 18.6198 7.38497 18.6084 7.37382C18.0968 6.87541 17.2763 6.87539 16.7647 7.37377L10.1069 13.8578L7.23828 11.0656C6.7267 10.5672 5.9061 10.5672 5.39457 11.0656C4.86848 11.5781 4.86848 12.4219 5.39457 12.9344L9.18362 16.6262C9.69519 17.1246 10.5158 17.1246 11.0273 16.6262L18.6054 9.24271C19.1196 8.74173 19.1313 7.92439 18.6403 7.40909Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }